import { inject, Injectable } from '@angular/core';
import { FileService } from './file-service';
import { SupabaseService } from '../supabase/supabase.service';
import { TenantsService } from '../tenants/tenants.service';

@Injectable()
export class SupabaseFileService implements FileService {
  private supabase = inject(SupabaseService);
  private tenantsService = inject(TenantsService);
  private expiresIn = 86400; // 24 hours

  async getFile(bucket: string, path: string): Promise<Blob | null> {
    return (await this.supabase.client.storage.from(bucket).download(path))
      .data;
  }

  async getAsset(path: string): Promise<Blob | null> {
    return this.getFile(
      'assets',
      `tenants/${this.tenantsService.id()}/${path}`,
    );
  }

  async getUrl(bucket: string, path: string): Promise<string | null> {
    return (
      (
        await this.supabase.client.storage
          .from(bucket)
          .createSignedUrl(path, this.expiresIn)
      ).data?.signedUrl || null
    );
  }
}
